import useLocaleObject from '~/composables/useLocaleObject';

export default () => {
  const locale = useLocaleObject();

  const currencyStore = useCurrencyStore();
  const currentCurrency = computed<string>(() => currencyStore.currency);

  return computed(() => {
    if (locale.value.code !== 'en') {
      return locale.value.iso.replace('-', '_');
    }

    switch (currentCurrency.value) {
      case 'EUR':
        return 'en_150';
      case 'USD':
        return 'en_US';
      case 'GBP':
        return 'en_GB';
      default:
        return 'en_001';
    }
  });
};
